import { createContext } from "react";
import { IServiceUserInfo } from "../datasolvr/ServicesFacade";
import { ICompanyContent, IEaterGroupContent, IOfficeContent, IUserContent, IVersionedObject } from "../planEatApi/PlanEatFacade";

export const PlanEatUserContext = createContext<IPlanEatUserContext | null>(null);
export const ApplicationUserContext = createContext<IApplicationUserContext | null>(null);
export const OfficeContext = createContext<IOfficeContext | null>(null);
export const CompanyContext = createContext<IOfficeContext | null>(null);
export const EaterGroupContext = createContext<IEaterGroupContext | null>(null);
export const AdminDateContext = createContext<IAdminDateContext | null>(null)


export interface IPlanEatUserContext {
    planEatServiceUser : IVersionedObject<IUserContent> | undefined;
    setPlanEatServiceUser : React.Dispatch<React.SetStateAction<IVersionedObject<IUserContent> | undefined>>;
}

export interface IApplicationUserContext {
    applicationServiceUser : IServiceUserInfo | undefined;
    setApplicationServiceUser : React.Dispatch<React.SetStateAction<IServiceUserInfo | undefined>>;
}

export interface ICompanyContext {
    company : IVersionedObject<ICompanyContent> | undefined;
    setCompany : React.Dispatch<React.SetStateAction<IVersionedObject<ICompanyContent> | undefined>>;
}

export interface IOfficeContext {
    office : IVersionedObject<IOfficeContent> | undefined;
    setOffice : React.Dispatch<React.SetStateAction<IVersionedObject<IOfficeContent> | undefined>>;
}

export interface IEaterGroupContext {
    eaterGroup : IVersionedObject<IEaterGroupContent> | undefined;
    setEaterGroup : React.Dispatch<React.SetStateAction<IVersionedObject<IEaterGroupContent> | undefined>>;
}

export interface IAdminDateContext {
    date: Date;
    setDate: React.Dispatch<React.SetStateAction<Date>>;
}
